<template>
  <keep-alive>
    <component :is="$store.state.layout" class="BG2">
      <AppLoading
        v-if="$store.state.isLoading || $store.state.isLoadingCustom"
      />
      <div class="form_parent">
        <router-view v-bind="callback" />
        <AppDialogMessageBox
          v-if="messageModal.show"
          v-model="messageModal.show"
          :modal="messageModal"
          @input="messageModal.callback()"
        ></AppDialogMessageBox>
        <AppConfirmDialog
          v-if="confirmMessage.show"
          v-model="confirmMessage.show"
          :modal="confirmMessage"
        ></AppConfirmDialog>
        <AppSnackBar
          v-if="snackBar.show"
          v-model="snackBar.show"
          v-bind="snackBar"
        ></AppSnackBar>
        <div
          v-if="tabData && tabData.pageForm && tabData.pageForm.show"
          class="page_overlay"
        >
          <abr-root v-bind="tabData.pageForm"></abr-root>
        </div>
        <div v-for="(modal, index) in tabData.modalForm" :key="index">
          <AppDialog
            v-model="modal.show"
            persistent
            :width="formWidth(modal.formSize)"
            @input="modal.callback()"
          >
            <abr-root v-bind="modal"></abr-root>
          </AppDialog>
        </div>
      </div>
    </component>
  </keep-alive>
</template>

<script>
import Default from "../layout/default";
import Auth from "../layout/auth";
import { fetchDefData } from "@/apis";
import AbrRoot from "@/components/AbrRoot";
import AppDialog from "@/components/library/container/AppDialog";
import AppDialogMessageBox from "@/components/library/container/AppDialogMessageBox";
import AppSnackBar from "@/components/library/container/AppSnackBar";
import AppLoading from "@/components/library/common/AppLoading";
// import sockets from "@/mixins/AbrSocketIO.js";
import { extend } from "@/ext";
import AppConfirmDialog from "./library/container/AppConfirmDialog";

export default {
  // mixins: [sockets],
  name: "AbrIndex",
  components: {
    AppDialogMessageBox,
    Default,
    Auth,
    AppDialog,
    AbrRoot,
    AppSnackBar,
    AppLoading,
    AppConfirmDialog,
  },
  data: () => ({
    callback: {},
    modal: { show: false },
    messageModal: { show: false },
    page: { show: false },
    snackBar: { show: false },
    confirmMessage: { show: false },
    modals: [],
  }),
  computed: {
    tabData() {
      return this.$store.getters.getActiveTab || {};
    },
  },
  async created() {
    this.$store.subscribeAction((action) => {
      if (action.type === "SHOW_APP_TAB") {
        const to = action.payload;

        this.callback = {
          callback: (model) => to.callback(model),
          model: to.params.model || {},
        };

        const isSameRoute =
          this.$route.name === to.name &&
          JSON.stringify(this.$route.params) === JSON.stringify(to.params) &&
          JSON.stringify(this.$route.query) === JSON.stringify(to.query);

        if (!isSameRoute) {
          this.$router.push(to);
        }
      } else if (action.type === "SHOW_CONFIRM_MESSAGE") {
        this.confirmMessage = {
          modal: {
            close: (confirmValue) => {
              this.confirmMessage.show = false;
              this.confirmMessage.confirm = confirmValue;
              return this.confirmMessage.callback(confirmValue);
            },
          },
          show: true,
          confirm: true,
          data: action.payload,
          callback: (modalState) =>
            action.payload.callback(this.confirmMessage, modalState),
        };
      } else if (action.type === "SHOW_MODAL") {
        const to = action.payload;

        if (to.params.formId || to.meta.formId) {
          const formId = to.params.formId || to.meta.formId;

          if (!to.params.mode)
            to.params.mode =
              to.params.id === "$new"
                ? "ECore.Def.DefEnums.fmCreate"
                : "ECore.Def.DefEnums.fmView";
          const tab = this.$store.getters.getActiveTab;
          this.modal = {
            modal: {
              close: (modalResult, model) => {
                tab.modalForm.pop();
                this.modal.show = false;
                return to.callback({ modalResult, model });
              },
            },
            show: true,
            formId,
            formSize: to.params.formWidth,
            mode: to.params.mode,
            model: to.params.model || {},
            callback: (modalResult, model) =>
              this.modal.modal.close(modalResult, model),
          };
          tab.modalForm.push(this.modal);
          this.$store.commit(
            "SET_TAB",
            tab,
            this.$store.state.tabManagement.activeTab,
          );
        }
      } else if (action.type === "SHOW_MESSAGE") {
        this.messageModal = {
          modal: {
            close: (modalResult) => {
              this.messageModal.show = false;
              return this.messageModal.callback(modalResult);
            },
          },
          show: true,
          data: action.payload,
          callback: (modalState) =>
            action.payload.callback(this.messageModal, modalState),
        };
      } else if (action.type === "SHOW_SNACKBAR") {
        this.snackBar = {
          snackBar: { close: () => (this.snackBar.show = false) },
          show: true,
          data: action.payload,
        };
      } else if (action.type === "SHOW_PAGE") {
        const to = action.payload;

        if (to.params.formId || to.meta.formId) {
          const formId = to.params.formId || to.meta.formId;

          if (!to.params.mode)
            to.params.mode =
              to.params.id === "$new"
                ? "ECore.Def.DefEnums.fmCreate"
                : "ECore.Def.DefEnums.fmView";
          this.page = {
            pageModal: {
              close: (pageResult, model) => {
                this.page.show = false;
                return this.page.callback(pageResult, model);
              },
            },
            show: true,
            formId,
            mode: to.params.mode,
            model: to.params.model || {},
            callback: (pageResult, model) =>
              to.callback({ pageResult, model: model }),
          };
          const tab = this.$store.getters.getActiveTab;
          tab.pageForm = this.page;
          this.$store.commit(
            "SET_TAB",
            tab,
            this.$store.state.tabManagement.activeTab,
          );
        }
      }
    });

    const init = async () => {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      const role = Object.keys(params).length > 0 ? params.role : Math.random();
      if (this.$store.state.root) return;

      if (!this.$store.state.auth.user) return;

      const defRoutes = await fetchDefData(
        "Root",
        {
          exclude: [
            ".*\\.@(entities|productSpec|fixedLabels|forms|stateMachines)",
            ":Schema",
          ],
          include: ["TSearchCondition"],
          resources: false,
          routes: true,
        },
        role,
      );
      const defRes = await fetchDefData("$resources", {}, role);

      if (!defRes || !defRoutes) return;

      const def = defRoutes;
      def.resources = defRes.resources;

      // extend(def)

      const forms = [];

      const traverse = (n, f) =>
        Array.isArray(n)
          ? n.map((i) => traverse(i, f))
          : n && n.kind && f(n) && Object.keys(n).map((k) => traverse(n[k], f));

      traverse(
        def,
        (n) => (n && Object.keys(n).length > 2 && forms.push(n)) || n,
      );

      this.$store.commit("SET_ROOT", def);

      this.$traverseData(forms);

      const resolveRef = function (id, start) {
        if (start.id === id)
          return (
            (start.id === id && start) ||
            (Array.isArray(start) && start.find((i) => resolveRef(id, i))) ||
            (start.kind &&
              Object.keys(start).find((k) => resolveRef(id, start[k])))
          );
      };

      def.resolveRef = (id) => resolveRef(id, def);

      const routes = Object.keys(def.routes).map((k) => ({
        path: "/:app/" + k,
        name: def.routes[k],
        component: async () => AbrRoot,
        meta: { formId: def.routes[k], authName: "abr" },
        props: () =>
          Object.assign({ formId: def.routes[k] }, this.$route.params),
      }));

      routes.unshift({
        path: "/:app",
        name: "AppHome",
      });

      this.$router.addRoutes(routes);

      const defaultApp =
        this.$store.state.app ||
        this.$store.state.root?.apps[0]?.name ||
        "AbrLA";

      this.$router.addRoutes([
        {
          path: "/",
          name: "Home",
          redirect: "/" + defaultApp,
        },
      ]);

      this.$vuetify.lang.locales["fa"] = {
        ...this.$vuetify.lang.locales["fa"],
        ...defRes,
      };
      const languageName = localStorage.getItem("lang");
      if (languageName === "en") {
        this.$store.commit("SET_LOCALE", "en-US");
      } else {
        this.$store.commit("SET_LOCALE", "fa-IR");
      }
      this.$store.commit("SET_LAYOUT", "Default");
      if (params && params.role) {
        this.$store.commit("SET_ROLE", params.role);
        this.$router.replace({ query: {} });
      }
    };
    if (this.$store.state.auth.user) {
      await init();
    } else {
      this.$store.state.auth.$on("userLoaded", init);
    }
  },
  methods: {
    formWidth(preset) {
      preset = typeof preset === "string" ? preset?.split(".").pop() : "";
      switch (preset) {
        case "fwFullWidth":
          return "100%";
        case "fwMediumWidth":
          return 786;
        case "fwLargeWidth":
          return 1122;
        default:
          return 786;
      }
    },
  },
};
</script>

<style>
@font-face {
  font-family: "IranYekan";
  src: url("../assets/fonts/IRANYekanBold.ttf") format("truetype");
}
@font-face {
  font-family: "IranYekanLight";
  src: url("../assets/fonts/IRANYekanLight.ttf") format("truetype");
}
@font-face {
  font-family: "IranYekanRegular";
  src: url("../assets/fonts/IRANYekanRegular.ttf") format("truetype");
}
@font-face {
  font-family: "IranYekanNum";
  src: url("../assets/fonts/IRANYekanRegularFaNum.ttf") format("truetype");
}
#app {
  font-family: "IranYekanNum";
}
i {
  text-align: center;
}
.page_overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 5;
}
.form_parent {
  position: relative;
}
</style>
